import { AnalyticsEvent } from "./analyticsEvent"
class AccordionInteractionEvent extends AnalyticsEvent {
    public accordionId: string;
    public accordionTitle: string;
    public sectionTitle: string;
    public sectionIndex: number;
    public interaction: string;
    public accordionLocation: string;
    constructor(accordionId: string, accordionTitle: string, sectionTitle: string, sectionIndex: number, interaction: string, location: string) {
        super();
        this.accordionId = accordionId;
        this.accordionTitle = accordionTitle;
        this.sectionTitle = sectionTitle;
        this.sectionIndex = sectionIndex;
        this.interaction = interaction;
        this.accordionLocation = location;
    }
}
export { AccordionInteractionEvent }